const AcquisioAdaptor = (adaptorPayload) => {

  const linkEvents = [ 'link-call', 'link-email', 'link-facebook',
            'link-file', 'link-instagram',
            'link-linkedin', 'link-twitter', 'link-yelp',
            'link-youtube', 'link-outgoing', 'link-homepage',
            'link-sms', 'link-get-directions']

  const client = window.ATRKtracker;

  // returns used npm testing purposes not required for live code
  if (adaptorPayload.analyticsEvent.name === 'form-submit') {
    client.setConversionCode('Form-Fill');
    return client.logConversion();
  } else if (linkEvents.includes(adaptorPayload.analyticsEvent.name)) {
    client.setConversionCode('Clicks_On_Links');
    return client.logConversion();
  }

}

export { AcquisioAdaptor }